/*
 * @Author: zhengshuhua
 * @Date: 2022-03-14 16:40:20
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-23 13:49:24
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\request\api\visit.js
 */
import { get } from '../axios'
const visit = {
	// 查询访视列表
	getSubjectVisitList: (subjectCode, researchCode) => get(`/web/recruitCenter/getSubjectVisitList/${subjectCode}/${researchCode}`),
	// 修改通用访视状态和计划访视状态时间
	updateVisitTimeStatus: (params) => get(`/web/recruitCenter/updateVisitTimeStatus/${params}`),
	// 查询访视状态
	getSubjectVisitStatus: (params) => get(`/web/recruitCenter/getSubjectVisitStatus/${params}`)
}
export default visit